/* Enhance only the field-guide section. Links and article content work without JS. */
(() => {
  const init = (root) => {
    if (root.dataset.guideReady) return;
    root.dataset.guideReady = 'true';
    const tableRegions = [];
    root.querySelectorAll('.gg-prose table').forEach((table, index) => {
      const wrap = document.createElement('div');
      wrap.className = 'gg-table-scroll';
      wrap.tabIndex = 0;
      wrap.setAttribute('role', 'region');
      wrap.setAttribute('aria-label', `Comparison table ${index + 1}, scroll horizontally if needed`);
      table.before(wrap);
      wrap.append(table);
      const hint = document.createElement('p');
      hint.className = 'gg-table-hint';
      hint.textContent = 'Swipe to compare →';
      wrap.before(hint);
      tableRegions.push({ wrap, table, hint });
    });
    const updateTables = () => tableRegions.forEach(({ wrap, table, hint }) => {
      const overflows = table.scrollWidth > wrap.clientWidth + 1;
      hint.hidden = !overflows;
      wrap.tabIndex = overflows ? 0 : -1;
    });
    requestAnimationFrame(updateTables);
    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(updateTables);
      tableRegions.forEach(({ wrap }) => observer.observe(wrap));
    }
    root.querySelectorAll('.gg-prose img').forEach((img) => {
      if (!img.hasAttribute('loading')) img.loading = 'lazy';
    });
    root.querySelectorAll('.gg-mobile-toc a').forEach((link) => {
      link.addEventListener('click', () => {
        root.querySelector('.gg-mobile-toc').open = false;
      });
    });
  };
  document.querySelectorAll('.rgc-gift-guide').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.rgc-gift-guide').forEach(init);
  });
})();
